import { TAccount } from '@helpers/Accounts/accounts.types';
import { getAccountIsInterestOnly } from '@helpers/Accounts/getAccountIsInterestOnly';
import { getAccountIsRBL } from '@helpers/Accounts/getAccountIsRBL';
import { getAccountIsRCF } from '@helpers/Accounts/getAccountIsRCF';
import { getAccountIsTermLoan } from '@helpers/Accounts/getAccountIsTermLoan';
import { fetchGetAccounts } from '@iwoca/lapi-client/edge';
import { useQuery } from '@tanstack/react-query';

import { useStateKey } from '../../../../iwQueryClient/useStateKey';
import { getLoanDurationInMonths } from '../../../myOffers/MyOffers.helpers';

type TLoanOverviewData = {
    account: TAccount;
    durationInMonths: number;
    loanStatus: TAccount['loan_status'];
    productType: TAccount['product_type'];
    isInInterestOnlyPeriod: TAccount['is_in_interest_only_repayment_period'];
    isRBL: boolean;
    isInterestOnlyLoan: boolean;
    isTermLoan: boolean;
    isRCF: boolean;
};

export const useGetDashboardTitleData = (
    accountId: string
): Partial<TLoanOverviewData> => {
    const stateKey = useStateKey();

    const { data: account } = useQuery({
        queryKey: ['accounts', stateKey],
        queryFn: () => fetchGetAccounts({ stateKey }),
        select: (data) =>
            data.data.accounts.find(
                (account) => account.account_id === accountId
            ),
        suspense: true
    });
    if (!account) {
        throw new Error();
    }
    const loanStatus = account.loan_status;

    return {
        durationInMonths: getLoanDurationInMonths(account.duration!),
        loanStatus,
        productType: account.product_type,
        isInInterestOnlyPeriod: account.is_in_interest_only_repayment_period,
        isInterestOnlyLoan: getAccountIsInterestOnly(account),
        isRBL: getAccountIsRBL(account),
        isTermLoan: getAccountIsTermLoan(account),
        isRCF: getAccountIsRCF(account)
    };
};
